import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Alert } from "reactstrap";
import { Header } from "./components/Header";
import Routes from "./routes";
import { EmployeeContextProvider } from "contexts/EmployeeContext";
import { useUserContext } from "./hooks";
import { OrganisationContextProvider } from "./hooks/useOrganisationContext";

import { useRecoilState } from "recoil";
import { showHeaderState } from './atoms'
import  { default as HeaderNew} from "./components/refactoring/Header";
import  { default as SidebarNew} from "./components/refactoring/Sidebar";
import  { default as LayoutHome} from "./components/refactoring/layouts/LayoutHome";
import  { default as LayoutUser} from "./components/refactoring/layouts/LayoutUser";
import  { default as LayoutLandingPage} from "./components/refactoring/layouts/LayoutLandingPage";
import { TipProvider } from './components/Tips/TipContext';

export const AppContainer = ({ children }) => {
  const { user } = useUserContext();
  const { t, i18n } = useTranslation();

  const [_showHeader] = useRecoilState(showHeaderState);


  return (
    <div className="">
    <div className="loader-holder" id="loader-holder"> </div>
      {/* For showing pages when user not logged in  */}
      { (_showHeader && !user ) ? 
          <LayoutLandingPage  body={children}>
            <Header/>
            {/* <Footer />  */}
          </LayoutLandingPage>
          : null
      } 

      {/* For showing pages when user logged in  */}
      { (_showHeader && user ) ? 
        <LayoutUser body={children}>
          <HeaderNew/>
          <SidebarNew/>
        </LayoutUser> 
        : null
      }

      {/* For showing (Home and Subscription components) 
       See Route.js Line:57
       */}
      { (!_showHeader && user ) ? <LayoutHome body={children}> <HeaderNew/></LayoutHome> : null} 
      </div>
  );
};

export const App = () => {
  const { user } = useUserContext();
  const trialDaysRemaining = user?.trial_days_remaining;

  
  return (
    <OrganisationContextProvider>
      <EmployeeContextProvider user={user}>
        <TipProvider>
          <AppContainer>
            {trialDaysRemaining > 0 ? (
            <Alert color="info" className="text-center text-sm py-1">
              <Trans>
                You have <strong>{{ trialDaysRemaining }}</strong> trial days remaining
              </Trans>
            </Alert>
          ) : null}
          
            <Routes/>
          </AppContainer>
        </TipProvider>
      </EmployeeContextProvider>
    </OrganisationContextProvider>
  );
};
